import React from "react";
import { TCText } from "../TCText/TCText";
import { Colors } from "../../utils/colors";
import { PayForAll } from "../payForAll/PayForAll";
import { SelectPlayersToPayOld } from "../selectPlayersToPay/SelectPlayersToPayOld";

type props = {};

export const PayForPlayersOld: React.FC<props> = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
      }}>
      <TCText
        style={{ fontWeight: 600, color: Colors.green, fontSize: 16 }}
        value="Select the players you want to pay for"
      />
      <div
        style={{
          border: `1px solid ${Colors.green}`,
          paddingTop: 24,
          paddingBottom: 24,
          paddingLeft: 20,
          paddingRight: 20,
          borderRadius: 20,
          marginTop: 15,
          width: "100%",
        }}>
        <PayForAll />
        <div
          style={{
            width: "100%",
            height: 2,
            backgroundColor: Colors.lightGreyBackground,
            marginBottom: 40,
            marginTop: 25,
          }}
        />
        <SelectPlayersToPayOld />
      </div>
    </div>
  );
};
